interface InfoListProps {
  items: string[];
  variant?: 'bullet' | 'checkmark' | 'cross';
  className?: string;
}

const InfoList: React.FC<InfoListProps> = ({ items, variant = 'bullet', className = '' }) => {
  const renderIcon = () => {
    switch (variant) {
      case 'checkmark':
        return <img src='/icons/privacy/checkmark.svg' alt='Checkmark' width={10} height={10} />;
      case 'cross':
        return <img src='/icons/privacy/cross.svg' alt='Cross' width={10} height={10} />;
      default:
        return <span className='h-1 w-1 rounded-full bg-[var(--Greys-400,#A1A1AA)]'></span>;
    }
  };

  return (
    <ul className={`space-y-2 ${className}`}>
      {items.map((item, index) => (
        <li key={index} className='flex items-center gap-2 text-sm text-[var(--Greys-400,#A1A1AA)]'>
          <span className='flex items-center justify-center'>{renderIcon()}</span>
          {item}
        </li>
      ))}
    </ul>
  );
};

export default InfoList;
